import { APP_NAME } from "@calcom/lib/constants";
import classNames from "@calcom/ui/classNames";

/**
 * Logo Kalienda.
 *
 * US-C3 — le logo est **duotone** (marine + turquoise). L'ancien traitement
 * `dark:brightness-0 dark:invert` l'aplatissait en blanc pur sur fond sombre, ce qui faisait
 * perdre l'accent turquoise. On sert désormais une **vraie variante sombre**
 * (`?type=logo-dark` / `?type=icon-dark`, cf. app/api/logo/route.ts) : marine → blanc,
 * turquoise → turquoise-400 (plus lumineux). Les deux images sont rendues et l'une des deux
 * est masquée selon le thème — une seule est visible, donc une seule est lue par les
 * lecteurs d'écran.
 */
export function Logo({
  small,
  large,
  icon,
  inline = true,
  className,
  src = "/api/logo",
}: {
  small?: boolean;
  /** Taille mise en avant (écrans d'authentification, onboarding). */
  large?: boolean;
  icon?: boolean;
  inline?: boolean;
  className?: string;
  src?: string;
}) {
  // `mx-auto` sur la variante `large` : le preflight Tailwind met `img { display: block }`,
  // donc un `text-center` sur le conteneur ne suffit PAS à centrer le logo.
  const imageClassName = icon
    ? "mx-auto w-9"
    : large
      ? "mx-auto h-8 w-auto"
      : small
        ? "h-4 w-auto"
        : "h-5 w-auto";
  const lightSrc = icon ? `${src}?type=icon` : src;
  const darkSrc = icon ? `${src}?type=icon-dark` : `${src}?type=logo-dark`;

  return (
    <h3 className={classNames("logo", inline && "inline", className)}>
      <strong>
        <img
          className={classNames(imageClassName, "dark:hidden")}
          alt={APP_NAME}
          title={APP_NAME}
          src={lightSrc}
        />
        {/* `dark:block` = le display natif de l'<img> sous le preflight Tailwind : les deux
            variantes se comportent donc STRICTEMENT à l'identique (même flux, même centrage). */}
        <img
          className={classNames(imageClassName, "hidden dark:block")}
          alt={APP_NAME}
          title={APP_NAME}
          src={darkSrc}
        />
      </strong>
    </h3>
  );
}
